/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from xplatforms/schemas/document_scanner/LegacyPage.yaml
import { ScanbotLegacyPageImpl } from './impl';
/**
 * Entry point for all legacy page features.
 */
export const ScanbotLegacyPage = {
    /**
     * Remove legacy page from the storage.
     * @param {Page} page - Page to be removed.
     * @returns {Promise<void>}
     * @deprecated
     */
    async removePage(page) {
        return ScanbotLegacyPageImpl.removePage(page);
    },
    /**
     * Remove all legacy pages from the storage.
     * @returns {Promise<void>}
     * @deprecated
     */
    async removeAllPages() {
        return ScanbotLegacyPageImpl.removeAllPages();
    },
    /**
     * Sets document image for a given page.
     * @param {Page} params.page - Page to be updated.
     * @param {string} params.imageFileUri - Image to be set.
     * @returns {Promise<Page>} - Updated page.
     * @deprecated
     */
    async setDocumentImage(params) {
        return ScanbotLegacyPageImpl.setDocumentImage(params);
    },
    /**
     * Recreates the given pages to refresh the image uris.
     * @param {Page[]} pages - Pages to be recreated.
     * @returns {Promise<Page[]>} - Recreated pages with refreshed image uris.
     * @deprecated
     */
    async refreshImageUris(pages) {
        return ScanbotLegacyPageImpl.refreshImageUris(pages);
    },
};
//# sourceMappingURL=LegacyPage.js.map